export default __webpack_public_path__ + "static/media/box2.e93eefc4.jpg";